import React from 'react';
import Image from 'next/image';
import { products } from '../../Data/ProductsData';
import Nero from "../../assets/icon/nero_logo.png"
import NeroInfinity from '../../assets/icon/nero_infinity_logo.png';
import Kairo from '../../assets/icon/kairo_logo.png';

import Slider from '@/Components/Slider';
import { NeroSliderArray } from '@/Components/NeroSlider';
import { NeroInfinitySliderArray } from '@/Components/NeroInfnitySlider';
import { WeatherSliderArray } from '@/Components/WeatherSlider';

import MetaHead from '@/Components/MetaHead';
import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';
import Button from '@/Components/Button';
import ContentTitle from '@/Components/ContentTitle';

export default function SoftwareProduct() {
  return (
    <div className="bg-white py-8 px-4 mx-auto text-left lg:py-16 lg:px-6">
      <MetaHead
        title="Hardware Product of Fyllo"
        description="The Kairo unit and Nero unit captures data from farm and is sent to Fyllo cloud server for analysis and processed using machine learning and AI agronomy models. From this data we generate crop specific advisory to the farmers"
      />
      <div className="mx-auto ">
        <MainHeading text="Our Hardware Products" />
        <SubHeading text="Get the most out of your farm with our innovative IoT platform that provides accurate and actionable data insights." />
      </div>
      <div className=" w-screen py-10 md:py-20 grid grid-cols-1 place-item-center  md:grid-cols-2  gap-6 px-5 md:px-44">
        <div className="w-full">
          <h2 className="pt-12 text-5xl text-green-900 font-black md:text-4xl">
            <Image
              width={200}
              height={200}
              className="w-4/5 mb-3"
              src={NeroInfinity}
              alt={'nero'}
              sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
            />
            <h2 className="text-xl md:text-xl font-bold text-gray-600 mb-0">
              Built With The World&apos;s Most Accurate SWR Technology!
            </h2>
          </h2>
          {/* <ul className="pt-6 max-w-md space-y-1 text-gray-500 list-inside ">
            <li className="flex flex-col text-slate-700 text-bold">
              <div className="flex   font-bold">
                <svg
                  className="fill-fyllo-800   h-7 w-7 mr-1.5 text-green-800  "
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>

                <ContentTitle styles=" mb-0 md:mb-0 " text="Real Time Irrigation Alerts" />
              </div>
              <p className="flex flex-col"></p>
              <ul className="pl-12 space-y-1 list-disc list-inside">
              </ul>
            </li>
            <li className="flex flex-col text-slate-700 text-bold">
              <div className="flex font-bold">
                <svg
                  className="fill-fyllo-800   h-7 w-7 mr-1.5 text-green-800  "
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <ContentTitle styles=" mb-0 md:mb-0" text="Precise fertilizer schedule" />
              </div>
              <p className="flex flex-col"></p>
              <ul className="pl-12 space-y-1 list-disc list-inside">
              </ul>
              <p></p>
            </li>
          </ul> */}
          <div className="grid grid-cols-1 gap-4 p-8 pl-12">
          <p className="w-2/3 font-medium border-2 border-[rgba(13,114,50,0.2)] text-center px-4 py-1 rounded-lg">
          REAL TIME IRRIGATION ALERTS
          </p>
          <p className="w-2/3 font-medium  border-2 border-[rgba(13,114,50,0.2)] text-center px-4 py-1 rounded-lg">
          PRECISE FERTILIZER SCHEDULE
          </p>
          </div>
          <ul>

            <li className="flex flex-col text-slate-700 text-bold">
              <div className="flex font-bold">
                <svg
                  className="fill-fyllo-800   h-7 w-7 mr-1.5 text-green-800  "
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <ContentTitle styles=" mb-0 md:mb-0" text="Touchless Sensor(long life)" />
              </div>

            </li>
            <li className="flex flex-col text-slate-700 text-bold">
              <div className="flex font-bold">
                <svg
                  className="fill-fyllo-800   h-7 w-7 mr-1.5 text-green-800  "
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <ContentTitle styles=" mb-0 md:mb-0" text="High Frequency EM Waves" />
              </div>

            </li>
            <li className="flex flex-col text-slate-700 text-bold">
              <div className="flex font-bold">
                <svg
                  className="fill-fyllo-800  h-7 w-7 mr-1.5 text-green-800  "
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <ContentTitle styles=" mb-0 md:mb-0" text="EV Grade Batteries With Solar Support" />
              </div>

            </li>
            <li className="flex flex-col text-slate-700 text-bold">
              <div className="flex font-bold">
                <svg
                  className="fill-fyllo-800  h-7 w-7 mr-1.5 text-green-800  "
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <ContentTitle styles=" mb-0 md:mb-0" text="e-SIM Technology" />
              </div>

            </li>
          </ul>
          <div className="grid grid-cols-1 gap-3 p-5 pl-12">
            <p className="w-2/3 flex justify-center flex-row px-4">
              <span className="text-3xs mb-1">₹</span>
              <span className="text-3xl font-bold">10,999/-</span>
              <span className="text-2xs mt-2 ml-2">only</span>
            </p>
            <div className="w-2/3 font-medium   text-center  rounded-lg">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSeA39JTJJIlOzfrHEsLU0lrmlJDr-Jz-gRuP-ycDICmA7ObYA/viewform">
                <button className=" bg-fyllo-800 w-full p-0 px-4 py-1 flex rounded-lg text-white items-center justify-center">
                  Book Now
                  <svg
                    aria-hidden="true"
                    className="w-4 h-4 ml-2 -mr-1"
                    fill="white"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
              </a>
            </div>
          </div>
          <div className="p-5"></div>
        </div>
        <div className="p-5 w-full h-full ">
          <Slider className="" imgArray={NeroInfinitySliderArray} />
        </div>
      </div>
      <div className="w-screen p-10  flex flex-col-reverse  md:grid  md:grid-cols-2 gap-6 px-5 md:px-44">
        <div className="p-5 w-full h-full ">
          <Slider className="" imgArray={WeatherSliderArray} />
        </div>
        <div className="w-full">
          <h2 className="pt-12 text-5xl text-900 font-black md:text-4xl">
            <Image
              width={200}
              height={200}
              className="w-1/2"
              src={Kairo}
              alt={'kairo'}
              sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
            />
          </h2>
          <p className="pt-6">
            Make informed decisions for your farm with our reliable Device <strong>Kairo</strong> that delivers
            in-depth data analysis and actionable insights, empowering you to achieve greater efficiency and
            profitability.
          </p>
          <div className="grid grid-cols-2 gap-5 p-5">
            <p className="font-medium  border-2 border-[rgba(13,114,50,0.2)] text-center px-4 py-2 rounded-lg">
              Irrigation Schedule
            </p>
            <p className="font-medium  border-2 border-[rgba(13,114,50,0.2)] text-center px-4 py-2 rounded-lg">
              Fertilizer Schedule
            </p>
            <p className="font-medium border-2 border-[rgba(13,114,50,0.2)] text-center px-4 py-2 rounded-lg">
              Disease/Pest Prediction
            </p>
            <p className="font-medium  border-2  border-[rgba(13,114,50,0.2)]  text-center px-4 py-2 rounded-lg">
              Weather Prediction
            </p>
          </div>
          <ul className="py-6 flex flex-col gap-6">
            <li className="flex flex-col text-slate-700 text-bold">
              <div className="flex  font-bold">
                <svg
                  className="fill-fyllo-800   h-9 w-9 mr-1.5 text-green-800  "
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <ContentTitle styles=" mb-0 md:mb-0" text="Weather Station" />
              </div>
              <p className="flex flex-col"></p>
              <ul className="pl-5 mt-2 space-y-1 list-inside grid grid-cols-2">
                <li> - 2 level soil moisture</li>
                <li> - Soil temperature</li>
                <li> - Air temperature</li>
                <li> - Air humidity</li>
                <li> - Air pressure</li>
                <li> - Leaf Wetness</li>
                <li> - Sunlight Intensity</li>
                <li> - Rainfall</li>
                <li> - Wind speed</li>
                <li> - Wind direction</li>
              </ul>
              <p></p>
            </li>
          </ul>
          <p className="w-4/5 flex flex-row justify-center mb-2.5">
            <span className="text-3xs mb-1">₹</span>
            <span className="text-3xl font-bold">70,000/-</span>
            <span className="text-2xs mt-1 ml-2">only</span>
          </p>
          <div className="w-2/3 font-medium   text-center  rounded-lg m-5 ">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeA39JTJJIlOzfrHEsLU0lrmlJDr-Jz-gRuP-ycDICmA7ObYA/viewform">
              <button className=" bg-fyllo-800 w-full p-0 px-4 py-1 flex rounded-lg text-white items-center justify-center">
                Book Now
                <svg
                  aria-hidden="true"
                  className="w-4 h-4 ml-2 -mr-1"
                  fill="white"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </a>
          </div>
        </div>
      </div>
      <div className=" w-screen py-10 md:py-20 grid grid-cols-1 place-item-center  md:grid-cols-2  gap-6 px-5 md:px-44">

      <div className="w-full">
        <h2 className="pt-12 text-5xl text-green-900 font-black md:text-4xl">
          <Image
            width={200}
            height={200}
            className="w-1/2"
            src={Nero}
            alt={'nero'}
            sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
          />
        </h2>
        <ul className="pt-6 max-w-md space-y-1 text-gray-500 list-inside ">
          <li className="flex flex-col text-slate-700 text-bold">
            <div className="flex   font-bold">
              <svg
                className="fill-fyllo-800   h-9 w-9 mr-1.5 text-green-800  "
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                ></path>
              </svg>

              <ContentTitle styles=" mb-0 md:mb-0 " text="Timely irrigation Alerts" />
            </div>
            <p className="flex flex-col"></p>
            <ul className="pl-12 space-y-1 list-disc list-inside">
              <p>based on your farm&apos;s soil, crop&apos;s variety, stage and sensor data</p>
            </ul>
          </li>
          <li className="flex flex-col text-slate-700 text-bold">
            <div className="flex font-bold">
              <svg
                className="fill-fyllo-800   h-9 w-9 mr-1.5 text-green-800  "
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <ContentTitle styles=" mb-0 md:mb-0" text="Precise fertilizer schedule" />
            </div>
            <p className="flex flex-col"></p>
            <ul className="pl-12 space-y-1 list-disc list-inside">
              <p>
                specific to your crop&apos;s variety and stage based on soil/leaf report and environmental conditions.
              </p>
            </ul>
            <p></p>
          </li>
        </ul>
        <div className="grid grid-cols-1 gap-3 p-5 pl-12">
          <p className="w-2/3 font-medium border-2 border-[rgba(13,114,50,0.2)] text-center px-4 py-1 rounded-lg">
            IMPROVED QUALITY
          </p>
          <p className="w-2/3 font-medium  border-2 border-[rgba(13,114,50,0.2)] text-center px-4 py-1 rounded-lg">
            GREATER YIELD
          </p>
          <p className="w-2/3 font-medium  border-2 border-[rgba(13,114,50,0.2)] text-center px-4 py-1 rounded-lg">
            LOWER COST PRODUCTION
          </p>
          <p className="w-2/3 flex justify-center flex-row px-4">
            <span className="text-3xs mb-1">₹</span>
            <span className="text-3xl font-bold">35,000/-</span>
            <span className="text-2xs mt-2 ml-2">only</span>
          </p>
          <div className="w-2/3 font-medium   text-center  rounded-lg">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeA39JTJJIlOzfrHEsLU0lrmlJDr-Jz-gRuP-ycDICmA7ObYA/viewform">
              <button className=" bg-fyllo-800 w-full p-0 px-4 py-1 flex rounded-lg text-white items-center justify-center">
                Book Now
                <svg
                  aria-hidden="true"
                  className="w-4 h-4 ml-2 -mr-1"
                  fill="white"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </a>
          </div>
        </div>
        <div className="p-5"></div>
      </div>
      <div className="p-5 w-full h-full ">
        <Slider className="" imgArray={NeroSliderArray} />
      </div>
      </div>
    </div>
  );
}
